
export default {
  namespaced: true,
  state: {
    id: null,
    customer: {},
    branchesRequests: [],
    typeName: '',
    cancellationApplicant: '', //解約者指名
    cancellationReasons: [],   //解約理由（複数）
    startTimeI18n: '',         //利用開始時期
  },

  getters: {
  },

  mutations: {
    setApply(state, payload) {
      state.id   = payload.id
      state.customer = payload.customer
      state.branchesRequests = payload.branchesRequests
      state.typeName = payload.typeName
      state.cancellationApplicant = payload.cancellationApplicant
      state.cancellationReasons = payload.cancellationReasons
      state.startTimeI18n = payload.startTimeI18n
    },
    initialize(state) {
      state.id   = null
      state.customer = ''
      state.branchesRequests = ''
      state.typeName = ''
      state.cancellationApplicant = ''
      state.cancellationReasons = ''
      state.startTimeI18n = ''
    },
  },

  actions: {
  },
}
